import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-footer-public',
  templateUrl: './app-footer-public.component.html',
  styleUrls: ['./app-footer-public.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppFooterPublicComponent { }



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/components/app-footer-public/app-footer-public.component.ts